import { User } from 'lib/types'

export function getNameFromUser(user?: User) {
  return user?.attributes.firstName && user?.attributes.lastName
    ? `${user.attributes.firstName} ${user.attributes.lastName}`
    : user?.attributes.firstName || user?.attributes.lastName || ''
}
